import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { getChatHistory } from "../../../store/thunks/common-thunks/commonThunk";
import { markProductAsRead } from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";
import { clearLiveMsgNotificationForProduct } from "../../../store/slices/common-slice/web-sockets/WebSocketMsgSlice";

import ChatMsgPad from "../chat-communication/ChatMsgPad";
import { Typography } from "../utils/antd-imports/AntdImports";

const ProductChatingPad = () => {
  const dispatch = useDispatch();
  const { campaignId, bookingId } = useParams();

  const { productsChatHistory } = useSelector((state) => state.chatHistory);
  const { isLiveMsgNotification } = useSelector((state) => state.webSocketMsgs);
  const { clientId } = useSelector((state) => state.userprofile);

  const normalizedCampaignId = useMemo(
    () => (campaignId ? String(campaignId) : null),
    [campaignId]
  );

  const normalizedBookingId = useMemo(
    () => (bookingId ? String(bookingId) : null),
    [bookingId]
  );

  /* ============================================================
     FETCH CHAT HISTORY
  ============================================================ */
  useEffect(() => {
    if (!normalizedCampaignId || !normalizedBookingId) return;

    dispatch(
      getChatHistory({
        campaignId: normalizedCampaignId,
        bookingId: normalizedBookingId,
      })
    );
  }, [dispatch, normalizedCampaignId, normalizedBookingId]);

  /* ============================================================
     MARK MESSAGE AS READ + CLEAR LIVE NOTIFICATION
  ============================================================ */
  useEffect(() => {
    if (!normalizedCampaignId || !normalizedBookingId) return;

    const hasActiveLiveMsg = isLiveMsgNotification?.some(
      (msg) =>
        String(msg.campaignId) === normalizedCampaignId &&
        String(msg.bookingId) === normalizedBookingId
    );

    if (!hasActiveLiveMsg) return;

    // 1️⃣ Mark product chat as read
    dispatch(
      markProductAsRead({
        campaignId: normalizedCampaignId,
        productId: normalizedBookingId,
        readAt: Date.now(),
      })
    );

    // 2️⃣ Remove from live notification list
    dispatch(
      clearLiveMsgNotificationForProduct({
        campaignId: normalizedCampaignId,
        productId: normalizedBookingId,
      })
    );
  }, [
    dispatch,
    isLiveMsgNotification,
    normalizedCampaignId,
    normalizedBookingId,
  ]);

  const chatData = productsChatHistory?.[0];

  return (
    <div
      style={{
        flex: 1,
        padding: 24,
        background: "#fff",
      }}
    >
      <ChatMsgPad
        senderName={chatData?.user_full_name}
        productId={chatData?.productId}
        bookingId={normalizedBookingId}
        campaignId={normalizedCampaignId}
        currentUserId={clientId}
        receiverUserId={chatData?.message_sender_id}
        chatHistory={chatData?.chatHistory || []}
      />
    </div>
  );
};

export default ProductChatingPad;
